import React from 'react'
import { Company } from '../../../../types/Company'

interface CompanySelectorProps {
    companies: Company[]
    selectedCompany: Company | null
    onCompanyChange: (company: Company | null) => void
}

export default function CompanySelector({ companies, selectedCompany, onCompanyChange }: CompanySelectorProps) {
    return (
        <div className="card mb-4">
            <div className="card-body">
                <div className="form-group">
                    <label>Paramétrage de la signature électronique pour la société :</label>
                    <select
                        className="form-control"
                        value={selectedCompany?.IDPlaque || ''}
                        onChange={(e) => {
                            const company = companies.find(c => c.IDPlaque === parseInt(e.target.value))
                            onCompanyChange(company || null)
                        }}
                    >
                        <option value="">Sélectionner une société</option>
                        {companies.map(company => (
                            <option key={company.IDPlaque} value={company.IDPlaque}>
                                {company.NomSociete} - {' '}
                                {!company.SignatureStatus ? (
                                    <span className="badge badge-info">Nouveau</span>
                                ) : (
                                    <span>{company.SignatureStatus}</span>
                                )}
                            </option>
                        ))}
                    </select>
                </div>
                {selectedCompany && (
                    <div>
                        <strong>Sites:</strong>
                        <ul>
                            {selectedCompany.Sites.map(site => (
                                <li key={site.IDSite}>{site.Descr}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )
}
